<script setup lang="ts">
import { useI18n } from 'vue-i18n'

withDefaults(
  defineProps<{
    value: string | number
    label: string
    selected?: boolean
    disabled?: boolean
  }>(),
  { selected: false, disabled: false },
)

const { t, te } = useI18n()
</script>
<template>
  <option :value="value" :selected="selected" :disabled="disabled" :e2e-option="value">
    {{ te(label) ? t(label) : label }}
  </option>
</template>
